export enum ETraitementState {
	aVenir = "à venir",
	enCours = "en cours",
	inconnu = "inconnu",
	interrompu = "interrompu",
	termine = "terminé"
}